module.exports = __webpack_public_path__ + "static/media/HomePageLogo_72dpi.da8a3770.png";